<template>
  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav> -->
  <ConfigProvider :locale="locale">
    <router-view />
  </ConfigProvider>
</template>

<script>
import { ConfigProvider } from 'ant-design-vue'
import zhCN from 'ant-design-vue/es/locale/zh_CN'

// 光 antdv 国际化没用,只生效一半
// dayjs 也得国际化才完全生效
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
dayjs.locale('zh-cn')

export default {
  name: 'app',
  components: { ConfigProvider },
  data() {
    return {
      locale: zhCN,
    }
  },
  async mounted() {
    // 企业微信配置已经在前端配置中，无需额外加载
    console.log('🔧 应用启动：企业微信配置已就绪')
    console.log('✅ 当前企业:', this.$store.state.wecomConfig.name)
    console.log('🏢 企业ID:', this.$store.state.wecomConfig.corp_id)
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
